import {Injectable} from '@angular/core';
import {FormbirdInjectorService} from '../injector/formbird-injector.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  ajsService: any;

  constructor(private injector: FormbirdInjectorService) {
    this.ajsService = injector.get('NotificationService');
  }

  /**
   * Display toast messages
   */
  public printMessage(message, messageType?, title?, position?, preventDuplicate?, displayDesktopNotification?,
                      onClickFunction?, timeOut?, isPermanent?) {
    return this.ajsService.printMessage(message, messageType, title, position, preventDuplicate, displayDesktopNotification,
      onClickFunction, timeOut, isPermanent);
  }

  public success(message, title?, displayDesktopNotification?) {
    return this.ajsService.success(message, title, displayDesktopNotification);
  }

  public error(message, title?, displayDesktopNotification?) {
    return this.ajsService.error(message, title, displayDesktopNotification);
  }

  public warning(message, title?, displayDesktopNotification?) {
    return this.ajsService.warning(message, title, displayDesktopNotification);
  }
}
